var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasOnboardingV3 && !_vm.skippableOnboarding)?_c('div',{staticClass:"onboarding-show-animation ai-onboarding",class:{
    'show': _vm.isOnboardingV3Showing,
    'onboarding-feature-based-options': true,
  },style:({
    '--onboarding-bg-img': `url(${_vm.onboardingBgImg})`,
  })},[(_vm.showUserScreening)?_c('user-screening',{on:{"skip":function($event){_vm.hideUserScreening = true},"done":function($event){_vm.hideUserScreening = true}}}):_vm._e(),(_vm.isLoadingFeatures && !_vm.showUserScreening)?_c('LoadingScreen'):_vm._e(),(!_vm.isLoadingFeatures && !_vm.showUserScreening)?[(_vm.canUseOnboardingRemoveSpinnerWheel)?_c('OnboardingThreeOptions'):_c('OnboardingFeatureBasedOptions')]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }